export const getAccessState = ({ user, trialStatus, subscriptionStatus, accountProfile }) => {
  const isSubscribed = subscriptionStatus === "active" || subscriptionStatus === "trialing";
  const isTrialActive = Boolean(trialStatus?.isTrialActive);
  const isCompanySeat =
    accountProfile?.accountBillingType === "companySeat" ||
    accountProfile?.billingExempt === true ||
    accountProfile?.subscriptionRequired === false;
  const isFounder = accountProfile?.isFounder === true;

  return {
    signedIn: Boolean(user),
    isSubscribed,
    isTrialActive,
    isCompanySeat,
    isFounder,
    hasAccess: Boolean(user) && (isSubscribed || isTrialActive || isCompanySeat || isFounder),
    offlineMessage:
      "Offline mode can load the app shell, but subscription and trial status must be verified online before unrestricted use.",
  };
};
